import { clearNotify, notify, requestSubmit, sendRequest } from "../api";
import {
    ADD_IN_LIST,
    RESET_FORM,
    RESET_STATE,
    SET_DETAIL,
    SET_FORM,
    SET_QUICK_LIST,
    UPDATE_FORM
} from "../constant-types";
import { updateField, getField } from "vuex-map-fields";

const getDefaultState = () => {
    return {
        detail: null,
        form: { purchase_items: [] },
        list_quick: []
    };
};

const getAvailableStock = (options, warehouseId) => {
    let idx = options.findIndex(o => o.warehouse_id === warehouseId)
    return idx >= 0 ? options[idx].base_qty_balance : 0
}

const getAvailableCashBalance = (options, userCashId) => {

}

export default {
    namespaced: true, //
    // variable
    state: getDefaultState(),
    // must syncronous
    mutations: {
        [ADD_IN_LIST](state, createdPurchaseReturn) {
            state.list_quick.unshift(createdPurchaseReturn);
        },
        ADD_OR_UPDATE_IN_LIST(state, purchaseReturn) {
            // find and update, when not found, then add by unshift
            let idx = state.list_quick.findIndex(lq => lq.id === purchaseReturn.id)
            if(idx >= 0) {
                state.list_quick[idx] = purchaseReturn
            } else {
                state.list_quick.unshift(purchaseReturn);
            }
        },
        [RESET_STATE](state) {
            // Merge rather than replace so we don't lose observers
            // https://github.com/vuejs/vuex/issues/1118
            Object.assign(state, getDefaultState());
        },
        [SET_FORM](state) {
            // take some info from detail and build form
            state.form = {
                id: state.detail.id,
                payment_total : state.detail.payment_total,
                payment_done : state.detail.payment_done,
                payment_return: state.detail.payment_return,
                payment_remain: state.detail.payment_remain,
                return_from_user_cash_id: state.detail.return_from_user_cash_id,
                ref_return_from_user_cash_balance_available: state.detail.ref_return_from_user_cash_balance_available, // init from detail
                ref_return_from_user_cash_balance_after: 0, // ilustrate when cash is not enough
                return_apply_by_id: state.detail.return_apply_by_id,
                has_return: state.detail.has_return,
                purchase_items: []
            };
            // item if have
            state.detail.purchase_items.forEach(dpi => {
                state.form.purchase_items.push({
                    id: dpi.id,
                    purchase_id: dpi.purchase_id,
                    product_name: dpi.product.name,
                    unit_name: dpi.unit.name,

                    stock_delivery_total: dpi.stock_delivery_total,
                    stock_delivery_received: dpi.stock_delivery_received,

                    option_stock_warehouses: dpi.product.stock_warehouses, // ref to return_from_warehouse_id
                    ref_stock_from_warehouse_available : getAvailableStock(dpi.product.stock_warehouses, dpi.return_from_warehouse_id),
                    ref_stock_from_warehouse_after: 0, // use just for ref, after subtracted from qty return

                    stock_delivery_return: dpi.stock_delivery_return,
                    return_reason: dpi.return_reason,

                    return_from_warehouse_id: dpi.return_from_warehouse_id,

                    stock_delivery_remain: dpi.stock_delivery_remain,
                    ref_stock_after_return: dpi.stock_delivery_received - dpi.stock_delivery_return
                });
            });
        },
        [RESET_FORM](state) {
            state.form = { purchase_items: [] };
        },
        [SET_DETAIL](state, createdPurchaseReturn) {
            state.detail = createdPurchaseReturn;
        },
        [SET_QUICK_LIST](state, payload) {
            state.list_quick = payload;
        },
        [UPDATE_FORM](state, { updateType }) {
            // -> update should divide to avoid revision issue
            // update return of payment
            if (updateType === 'payment') {
                // update return of payment
                state.form.ref_return_from_user_cash_balance_after = state.form.ref_return_from_user_cash_balance_available - state.form.payment_return
                state.form.payment_remain = state.form.payment_total - state.form.payment_done
            } 
            // update remain calculation on purchase items
            else if (updateType === 'items') {
                state.form.purchase_items.forEach(fpi => {
                    fpi.ref_stock_from_warehouse_after = fpi.ref_stock_from_warehouse_available - fpi.stock_delivery_return

                    fpi.ref_stock_from_warehouse_after = fpi.ref_stock_from_warehouse_available - fpi.stock_delivery_return
                    fpi.ref_stock_after_return = fpi.stock_delivery_received - fpi.stock_delivery_return
                })
            }
        },
        updateField
    },
    // can async
    actions: {
        loadDetail({ commit, rootGetters }, purchaseId) {
            return sendRequest(
                `purchase-return/purchase/${purchaseId}`,
                {},
                "get",
                purchaseReturn => {
                    // insert available user cash
                    purchaseReturn['ref_return_from_user_cash_balance_available'] = rootGetters['userCash/getUserCashBalance'](purchaseReturn.return_from_user_cash_id)
                    commit(SET_DETAIL, purchaseReturn)
                }
            );
        },
        loadQuickList({ commit }) {
            return sendRequest("purchase-return/quick", {}, "get", quickList =>
                commit(SET_QUICK_LIST, quickList)
            );
        },
        requestCreatePurchaseReturn({ commit, state, dispatch }) {
            return requestSubmit(
                "purchase-return",
                state.form,
                commit,
                "post",
                createdPurchaseReturn => {
                    commit('ADD_OR_UPDATE_IN_LIST', createdPurchaseReturn),
                        // refresh user cash
                        dispatch("userCash/loadList", null, {
                            root: true
                        });
                    // set to detail
                    commit(SET_DETAIL, createdPurchaseReturn);
                    // reset form
                    commit(RESET_FORM)
                }
            );
        }
    },
    // call variable with custom display
    getters: {
        formValidated: state => {
            // when remain stock not negative and selected stock warehouse house must have enough stock to return it back, also payment remain should not negative
            if (state.form) {
                if (state.form.ref_return_from_user_cash_balance_after < 0) return false

                return state.form.purchase_items.every( pi => {
                    if (pi.ref_stock_after_return < 0) return false
                    if (pi.stock_delivery_return < 0) return false
                    if (pi.stock_delivery_remain < 0) return false
                    if (pi.ref_stock_from_warehouse_after < 0) return false
                    if (!pi.return_reason) return false

                    return true
                })
            } else {
                return false;
            }
        },
        // should not exceed received, but also should see warehouse stock
        maxReturnAllowed: state => (itemIndex) => {
            let stockDeliveryReceived = state.form.purchase_items[itemIndex].stock_delivery_received
            let availableStockWarehouse = state.form.purchase_items[itemIndex].ref_stock_from_warehouse_available 

            return stockDeliveryReceived <= availableStockWarehouse ? stockDeliveryReceived : availableStockWarehouse
        },
        getField
    }
};
